// extracted by mini-css-extract-plugin
module.exports = {"title":"OfferDeactivateView_title__2ipY1","description":"OfferDeactivateView_description__1zhU8"};